import { darkTheme, lightTheme } from 'styles/themes'

interface IContentGuide {
  image: string
  title: string
  text?: string
  step: number
  stepsIsOrange?: boolean
  isMobile: boolean
  isDarkMode: boolean
}

const ContentGuide: React.FC<IContentGuide> = ({
  image,
  title,
  text,
  stepsIsOrange,
  step,
  isMobile,
  isDarkMode,
}: IContentGuide) => {
  const buttonSteps = (step: number, isOrange?: boolean) => {
    const activeColor = isOrange
      ? isDarkMode
        ? `rgb(${darkTheme.primary.base})`
        : `rgb(${lightTheme.primary.base})`
      : '#FFFFFF'

    const buttonStyle = {
      cursor: 'auto',
      width: '14px',
      height: '14px',
      margin: '7px',
      border: 'none',
      borderRadius: '50%',
      background: '#D9D9D9',
    }

    return (
      <div style={{ marginBottom: '2rem' }}>
        <button id="step1" style={{ ...buttonStyle, background: activeColor }} disabled></button>
        <button
          id="step2"
          style={step > 1 && step <= 3 ? { ...buttonStyle, background: activeColor } : buttonStyle}
          disabled
        ></button>
        <button
          id="step3"
          style={step === 3 ? { ...buttonStyle, background: activeColor } : buttonStyle}
          disabled
        ></button>
      </div>
    )
  }

  return (
    <div>
      {!isMobile ? buttonSteps(step, stepsIsOrange) : ''}
      <strong>{title}</strong>
      <p>
        <img className="cover-footer" src={image} alt="Direção Concursos Bar" />
      </p>
      <p>{text}</p>
      {isMobile ? buttonSteps(step, stepsIsOrange) : ''}
    </div>
  )
}

export default ContentGuide
